import { SxProps } from "@mui/material";

export const containerSX:SxProps = {
    alignItems:'center',
    marginTop:'0 !important',
    '& .rating_summary':{
        display:'flex',
        alignItems:'center',
        justifyContent:'space-between'
    },
    '& >span':{
        fontSize:14
    }
}